/**
 * portalGerekce.js — "neden yapamıyorum?" metinleri (backlog #418, 2026-10-14; tasarım #409).
 *
 * Backend (PortalYetkiCozucu) her modül ve her organizatör eylemi için bir GEREKÇE verir: seviyeyi hangi girdi sınırlıyor.
 *   SET_CAP             firmanın bu fuardaki rolü (arayüz seti) izin vermiyor
 *   ROLE                girişin portal rolü izin vermiyor (rol adları parantez içinde)
 *   COMPANY_RESTRICTION SAKA bu modülü firma için kısıtladı (personelin yazdığı gerekçe eklenir)
 *   ORGANIZER_SETTING   SAKA bu işlemi firma için açmadı (yalnızca organizatör eylemleri)
 * Bu dosya o kodu, devre dışı bir düğmenin üstünde gösterilecek cümleye çevirir; saf işlevler, bağlam bunları bağlar.
 * Metinler portal:gerekce.* anahtarlarında (tr + en).
 */
import i18n from '../i18n';

const BILINEN = new Set(['SET_CAP', 'ROLE', 'COMPANY_RESTRICTION', 'ORGANIZER_SETTING']);

/** { kod: ad } — girişin portal rollerinin adları (istek dilinde). */
function rolAdlari(kullaniciRolleri) {
  const out = {};
  for (const r of kullaniciRolleri || []) out[r.kod] = r.ad;
  return out;
}

/**
 * Bir gerekçe (ve varsa kaynağı) için cümle. `ayrinti`: { kaynak, kisitGerekcesi }.
 * Bilinmeyen / boş gerekçe → null (gösterilecek bir şey yok).
 */
export function gerekceMetni(gerekce, ayrinti = {}, kullaniciRolleri = []) {
  if (!gerekce || !BILINEN.has(gerekce)) return null;
  let metin = i18n.t(`portal:gerekce.${gerekce}`);
  if (gerekce === 'ROLE') {
    const adlar = rolAdlari(kullaniciRolleri);
    const kodlar = String(ayrinti.kaynak || '').split(',').map((s) => s.trim()).filter(Boolean);
    const isimler = (kodlar.length ? kodlar : Object.keys(adlar)).map((k) => adlar[k] || k);
    if (isimler.length) metin = i18n.t('portal:gerekce.rolAdiyla', { metin, roller: isimler.join(', ') });
  }
  if (gerekce === 'COMPANY_RESTRICTION' && ayrinti.kisitGerekcesi) {
    metin = i18n.t('portal:gerekce.nedenle', { metin, neden: ayrinti.kisitGerekcesi });
  }
  return metin;
}

/**
 * Bir modül için: `set` PortalContext'in arayüz seti (moduller + gerekceler). Seviye `min`'e ulaşıyorsa null (engel yok).
 * @param seviyeSirasi ['NONE','READ','WRITE','MANAGE']
 */
export function modulIpucu(set, modul, min, kullaniciRolleri, seviyeSirasi = ['NONE', 'READ', 'WRITE', 'MANAGE']) {
  if (!set) return null;
  const seviye = set.moduller?.[modul] ?? 'NONE';
  if (seviyeSirasi.indexOf(seviye) >= seviyeSirasi.indexOf(min)) return null;
  const g = set.gerekceler?.[modul];
  return gerekceMetni(g?.gerekce || 'SET_CAP', g || {}, kullaniciRolleri);
}

/** Bir organizatör eylemi için; eylem izinliyse null. `set`: ORGANIZATOR arayüz seti. */
export function eylemIpucu(set, kod, kullaniciRolleri) {
  const e = (set?.eylemler || []).find((x) => x.kod === kod);
  if (!e || e.izinli) return null;
  // Eylemin gerekçesi modül kaynaklıysa (SET_CAP / ROLE / COMPANY_RESTRICTION) ayrıntı o modülün gerekçesinden gelir.
  const ayrinti = (e.modul && set.gerekceler?.[e.modul]) || {};
  return gerekceMetni(e.gerekce || 'SET_CAP', e.gerekce === 'ROLE' || e.gerekce === 'COMPANY_RESTRICTION' ? ayrinti : {}, kullaniciRolleri);
}
